angular.module('leanlaw').factory('billingFilterService', ['$state', '$stateParams', function ($state, $stateParams) {
  const localState = {
    range: {}
  };
  return {
    state: localState
  };
}]);